/**
 * 固定值类
 * @type {{}}
 */
const contentFun = {

    getNewsCss:()=>{
        let typeArr =[
            //{value:1,label:"一般资讯"},
            {value:'Risk',menuClass:"nav1"},
            {value:'Advisory',menuClass:"nav2"},
            {value:'Information',menuClass:"nav3"},
            {value:'Outsourcing',menuClass:"nav4"},
            {value:'about',menuClass:"nav5"},
        ];
        return typeArr;
    },

    formartDate:(datetime)=>{
        if(datetime==undefined || datetime == null){
            return '';
        }
        let pos = datetime.indexOf(' ');
        if(pos <0){
            return datetime;
        }
        const [datePart, timePart] = datetime.split(' ');
        return datePart;
    },

    /**
     * 子菜单匹配路由
     * @param type
     * @param code
     * @param id
     * @return {string}
     */
    getRouter:(pcode,code,id)=>{
        let typeArr =[
            //风险控制
            {type:1,pcode:'Risk',code:'RiskQdsj',router:"RiskQdsj",matchId:0},
            {type:1,pcode:'Risk',code:'hgsj',router:"hgsj",matchId:0},
            {type:1,pcode:'Risk',code:'gyssj',router:"gyssj",matchId:0},
            {type:1,pcode:'Risk',code:'xxdc',router:"xxdc",matchId:0},
            {type:1,pcode:'Risk',code:'xxdc',router:"xxdc",matchId:1},
            //咨询管理
            {type:2,pcode:'Advisory',code:'glzxjj',router:"Advisory",matchId:0},  //glzxjj
            {type:2,pcode:'Advisory',code:'zjgwtjj',router:"zjgwtjj",matchId:0},
            {type:2,pcode:'Advisory',code:'RiskQdsj',router:"RiskQdsj",matchId:0},
            {type:2,pcode:'Advisory',code:'RiskQdsj',router:"RiskQdsj",matchId:1},
            //新闻中心
            {type:3,pcode:'Outsourcing',code:'xwzx',router:"Outsourcing",matchId:0},
            {type:3,pcode:'Outsourcing',code:'qydt',router:"qydt",matchId:0},
            {type:3,pcode:'Outsourcing',code:'xwzx',router:"Outsourcing",matchId:1},
            //信息技术
            {type:4,pcode:'Information',code:'xxjspdy',router:"Information",matchId:0},
            {type:4,pcode:'Information',code:'yssjk',router:"yssjk",matchId:0},
            {type:4,pcode:'Information',code:'bi',router:"bi",matchId:0},
            {type:4,pcode:'Information',code:'jjjspt',router:"jjjspt",matchId:0},
            {type:4,pcode:'Information',code:'ipad',router:"ipad",matchId:0},
            {type:4,pcode:'Information',code:'ipad',router:"ipad",matchId:1},
            //关于我们
            {type:5,pcode:'about',code:'gywm',router:"gywm",matchId:0},
            {type:5,pcode:'about',code:'qyjg',router:"qyjg",matchId:0},
            {type:5,pcode:'about',code:'hwkh',router:"hwkh",matchId:0},
            {type:5,pcode:'about',code:'wmdyj',router:"wmdyj",matchId:0},
            {type:5,pcode:'about',code:'wmdjzg',router:"wmdjzg",matchId:0},
            {type:5,pcode:'about',code:'lxwm',router:"lxwm",matchId:0},
            {type:5,pcode:'about',code:'lxwm',router:"lxwm",matchId:1},

            //友情链接
            {type:6,pcode:'link',code:'link',router:"link",matchId:0},
            {type:6,pcode:'link',code:'link',router:"link",matchId:1},
        ];
        let match =false;
        for(let i=0; i< typeArr.length; i++){
            let item = typeArr[i];
            if(pcode == item.pcode){
                if(code == item.code){
                    return item.router;
                }
            }
        }
        //新增的没有指定code
        if(!match){
            for(let i=0; i< typeArr.length; i++){
                let item = typeArr[i];
                if(pcode == item.pcode){
                    if(1 == item.matchId){
                        return item.router +"?id="+ id;
                    }
                }
            }
        }
        //没有找到的返回首页
        return "/";
    },

    getAdvisoryArr:(index)=>{

    },

    /*
    valuesList:{
                    group_10: require('@/assets/home/home_my_value_01.png'),
                    group_11: require('@/assets/home/home_my_value_02.png'),
                    group_12: require('@/assets/home/home_my_value_03.png'),
                    group_14: require('@/assets/home/home_my_value_04.png'),
                },
     */
    dealPic:(data,funModel,isArr) =>{
        if(data && data.length>0){
            let picarr= data.filter(item => item.funModel === funModel);
            if(picarr && picarr.length>0){
                if(isArr){
                    let arr =[];
                    for(let i=0;i< picarr.length;i++){
                        arr.push(picarr[i].url);
                    }
                    return arr;
                }else{
                    return picarr[0].url;
                }
            }
        }
    },

}


export default contentFun;
